import DebtInfo from "./components/DebtInfo";

export default DebtInfo;
